import { useContext } from 'react'

import { ColorSchemeContext } from '@/modules/shared/providers/ColorSchemeContext'

export function useColorScheme() {
  const context = useContext(ColorSchemeContext)
  if (!context) {
    throw new Error('useColorScheme must be used within ColorSchemeProvider')
  }
  return context
}
